/**
 * Product feature flags — plain constants, flipped in code and shipped with a
 * normal deploy (push to main). Components read them at render time, so tests
 * override them per case via `vi.mock('@/lib/flags')`.
 */
export interface Flags {
  /**
   * Advisory pricing while building a purchase order request
   * (/purchasing/new): the search hits' "from $/kg", the Pack picker's per-kg
   * prices, each line's live price + total, the cheaper-pack nudge, and the
   * review step's Price / kg + Total columns and estimated total. Off = the
   * wizard shows packs and kg only; customers get confirmed pricing after
   * they send the request. Copy that promises live pricing follows it too.
   *
   * Off for every customer since 2026-10 (support case 00004001).
   */
  readonly purchasingPricing: boolean
}

export const flags: Flags = {
  purchasingPricing: false,
}
